import { render, staticRenderFns } from "./dataTemplate.vue?vue&type=template&id=ac263238&scoped=true"
import script from "./dataTemplate.vue?vue&type=script&lang=js"
export * from "./dataTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac263238",
  null
  
)

export default component.exports